module.exports = {"top3":["Hospital 30-day mortality","Children without a medical home","Nursing home residents with a hospital admission"],"bottom3":["Breast cancer deaths","Potentially avoidable emergency department visits age 65 and older","Drug poisoning deaths"],"most_improved":["Nursing home residents with an antipsychotic medication","Diabetic adults without an annual hemoglobin A1c test","Home health patients without improved mobility"],"most_declined":["Adults who are obese","Preventable hospitalizations ages 18-64","Drug poisoning deaths"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/OH.json
// module id = 275
// module chunks = 143196823979170 184088790168614